var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"VideoPlayIcon is-flex-centered"},[_c('clr-icon',{staticClass:"is-solid has-text-white",attrs:{"shape":"play","size":_vm.size}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }